import { render, staticRenderFns } from "./SupplementalCostViewComponent.vue?vue&type=template&id=2e933008&scoped=true"
import script from "./SupplementalCostViewComponent.vue?vue&type=script&lang=js"
export * from "./SupplementalCostViewComponent.vue?vue&type=script&lang=js"
import "./SupplementalCostViewComponent.vue?vue&type=style&index=0&id=2e933008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e933008",
  null
  
)

export default component.exports